import { render, staticRenderFns } from "./LatestMedia.vue?vue&type=template&id=23de5f6a&"
import script from "./LatestMedia.vue?vue&type=script&lang=ts&"
export * from "./LatestMedia.vue?vue&type=script&lang=ts&"
import style0 from "./LatestMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports